'use strict'
import createApp from '@shopify/app-bridge';
import {
    getSessionToken
} from "@shopify/app-bridge-utils";
import {
    Button,
    History,
    Redirect,
    TitleBar,
} from '@shopify/app-bridge/actions';
import {
    AppContext
} from '@lightspeed-invoicing/core-client/frontend';
import EventBus from '../common/EventBus.js';
import GlobalHelper from '../common/GlobalHelper.jsx';

class ShopifyContext {

    constructor() {
        this.app = null
        this.titleBar = null
        this.breadcrumb = null
        this.origin = ""
        this.apiKey = ""
        this.breadcrumbLocation = ""
        this.history = null
        this.redirect = null
        this.integrationKey = ""
    }

    async setOrigin(origin, hostToUse, integrationKey) {
        let host = GlobalHelper.getShopifyIntegrationHost()
        if (hostToUse) {
            host = hostToUse
        }
        let integrations
        if (integrationKey) {
            integrations = await AppContext.getApiClient().get('/public-integration-configurations?empty=true&integrationKey=' + integrationKey)
        } else {
            integrations = await AppContext.getApiClient().get('/public-integration-configurations?externalAccountId=' + origin)
        }

        const integration = integrations.data ? integrations.data[0] : null
        const apiKey = integration ? integration.attributes.configuration.clientId : ''

        this.origin = origin
        this.apiKey = apiKey
        this.app = createApp({
            apiKey: apiKey,
            host: host,
            shopOrigin: this.origin,
        })
        this.history = History.create(this.app)
        this.redirect = Redirect.create(this.app)
        this.integrationKey = integration ? integration.attributes.integrationKey : ''
    }

    getAppState() {
        return this.app.getState()
    }

    getSessionTokenPromise() {
        console.log("App loading...")
        console.log(this.app)
        return getSessionToken(this.app)
    }

    loadBreadcrumbs() {
        this.breadcrumb = Button.create(this.app, {
            label: ""
        })
        const titleBarOptions = {
            title: 'QM',
            breadcrumbs: this.breadcrumb,
        }
        this.titleBar = TitleBar.create(this.app, titleBarOptions)

        this.breadcrumb.subscribe(Button.Action.CLICK, () => {
            EventBus.dispatch(EventBus.TopicHistoryPush, {
                path: this.breadcrumbLocation,
            })
        })
    }

    setBreadcrumbs(breadcrumbs) {
        if (!this.breadcrumb || !this.titleBar) {
            this.loadBreadcrumbs()
        }

        if (breadcrumbs.length > 1) {
            this.breadcrumb.set({
                label: breadcrumbs[breadcrumbs.length - 2].stringLabel
            })
            this.breadcrumbLocation = breadcrumbs[breadcrumbs.length - 2].link
        } else {
            this.breadcrumb.unsubscribe()
            this.breadcrumb = undefined
        }

        this.titleBar.set({
            title: breadcrumbs[breadcrumbs.length - 1].stringLabel,
            breadcrumbs: this.breadcrumb,
        })
    }

    replaceCurrentHistory(location) {
        if (location && location.pathname) {
            this.history.dispatch(History.Action.REPLACE, location.pathname)
        }
    }

    redirectToDashboard() {
        this.redirect.dispatch(Redirect.Action.APP, '/')
    }

    redirectTo(path) {
        this.redirect.dispatch(Redirect.Action.APP, path)
    }
}

const ShopifyAppContext = new ShopifyContext()

export default ShopifyAppContext


// WEBPACK FOOTER //
// ./src/shopify/shopifyappcontext.js